import React, { useState } from 'react';
import UserManagement from './UserManagement';
import RoleManagement from './RoleManagement';

const UserRoleManager: React.FC = () => {
  const [currentView, setCurrentView] = useState<'users' | 'roles'>('users');

  const handleNavigateToRoles = () => {
    setCurrentView('roles');
  };

  const handleNavigateToUsers = () => {
    setCurrentView('users');
  };

  return (
    <>
      {currentView === 'users' && (
        <UserManagement onNavigateToRoles={handleNavigateToRoles} />
      )}
      {currentView === 'roles' && (
        <RoleManagement onBackToUsers={handleNavigateToUsers} />
      )}
    </>
  );
};

export default UserRoleManager;
